import DOMPurify from 'isomorphic-dompurify';

const SAFE_LINK_URI = /^(?:(?:https?|mailto):|\/)/i;

export function sanitizeLinksOnly(input?: string) {
  if (!input) return '';

  return DOMPurify.sanitize(input, {
    ALLOWED_TAGS: ['a'],
    ALLOWED_ATTR: ['href', 'title', 'target', 'rel'],
    ALLOWED_URI_REGEXP: SAFE_LINK_URI,
  });
}

export function sanitize(input?: string) {
  if (!input) return '';
  return DOMPurify.sanitize(input);
}

export function sanitizeBasicFormatting(input?: string) {
  if (!input) return '';
  return DOMPurify.sanitize(input, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'br'],
    ALLOWED_ATTR: ['href', 'title', 'target', 'rel'],
    ALLOWED_URI_REGEXP: SAFE_LINK_URI,
  });
}

export function sanitizeHighlighting(input?: string) {
  if (!input) return '';
  return DOMPurify.sanitize(input, {
    ALLOWED_TAGS: ['em'],
    ALLOWED_ATTR: [],
  });
}
